/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

class LuiIconLoader {
  loadSvg(icon) {
    return new Promise((resolve, reject) => {
      const xhr = new window.XMLHttpRequest()
      xhr.open('GET', icon, true)
      xhr.send()
      xhr.addEventListener('load', (e) => {
        if (e.target.status >= 200 && e.target.status < 300) {
          resolve(xhr.responseText)
        } else {
          reject(e.srcElement.status)
        }
      })
    })
  }
}

export default new LuiIconLoader()



//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/loader/lui-icon-loader.js
// module id = 139
// module chunks = 0 1 12